import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReusableTable from "./../components/ReusableTable";
import { getApiUrl, BASE_URL } from "./../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SubCategoryPage = () => {
  const UserId = "66abc123def4567890abcd12";

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchCategories = async () => {
    const res = await fetch(getApiUrl("category-list"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId }),
    });
    const result = await res.json();
    if (result.success) setCategories(result.data);
  };

  const fetchSubcategories = async () => {
    const res = await fetch(getApiUrl("subcategory-list"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId }),
    });
    const result = await res.json();
    if (result.success) setSubcategories(result.data);
  };

  useEffect(() => {
    fetchCategories();
    fetchSubcategories();
  }, []);

  const openAddModal = () => {
    setEditId(null);
    formik.resetForm();
    setSelectedImage(null);
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setEditId(item._id);
    formik.setFieldValue("name", item.name);
    formik.setFieldValue("categoryid", item.categoryid);
    setSelectedImage(null);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const res = await fetch(getApiUrl("subcategory-delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId, subcategoryid: id }),
    });
    const result = await res.json();

    if (result.success) {
      toast.success("Deleted Successfully!");
      fetchSubcategories();
    }
  };

  const formik = useFormik({
    initialValues: { name: "", categoryid: "" },
    validationSchema: Yup.object({
      name: Yup.string().required("Subcategory name required"),
      categoryid: Yup.string().required("Category is required"),
    }),

    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("categoryid", values.categoryid);
      formData.append("userid", UserId);
      if (editId) formData.append("subcategoryid", editId);
      if (selectedImage) formData.append("image", selectedImage);

      const url = editId
        ? getApiUrl("subcategory-update")
        : getApiUrl("subcategory-add");

      const res = await fetch(url, { method: "POST", body: formData });
      const result = await res.json();

      if (result.success) {
        toast.success(editId ? "Updated Successfully!" : "Added Successfully!");
        setShowModal(false);
        fetchSubcategories();
      } else toast.error(result.message);
    },
  });

  const columns = [
    { name: "Name", selector: (row) => row.name },

    {
      name: "Category",
      selector: (row) => {
        const category = categories.find((c) => c._id === row.categoryid);
        return category ? category.name : "No Category";
      },
    },

    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${BASE_URL}${row.imageUrl}`}
          alt="subcategory"
          width="60"
          height="60"
          className="rounded border"
        />
      ),
    },

    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-warning btn-sm me-2"
            onClick={() => openEditModal(row)}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </button>

          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={5000} />

      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">Subcategory Management</h3>
        <button className="btn btn-primary" onClick={openAddModal}>
          + Add Subcategory
        </button>
      </div>

      <ReusableTable
        columns={columns}
        data={subcategories}
        title="Subcategory List"
      />

      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h4 className="modal-title fw-bold">
                  {editId ? "Edit Subcategory" : "Add Subcategory"}
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <form onSubmit={formik.handleSubmit}>
                <div className="modal-body">
                  <div className="floating-label">
                    <input
                      type="text"
                      name="name"
                      placeholder=" "
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      required
                    />
                    <label>Sub-category Name</label>
                  </div>

                  <div className="form-floating mt-3">
                    <select
                      className="form-select"
                      id="floatingCategory"
                      name="categoryid"
                      value={formik.values.categoryid}
                      onChange={formik.handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat._id} value={cat._id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="floatingCategory">Category</label>
                  </div>

                  <input
                    type="file"
                    className="form-control mt-3"
                    onChange={(e) => setSelectedImage(e.target.files[0])}
                  />

                  {selectedImage && (
                    <img
                      src={URL.createObjectURL(selectedImage)}
                      alt="preview"
                      width="120"
                      className="rounded mb-3 border mt-3"
                    />
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button type="submit" className="btn btn-success">
                    {editId ? "Update Subcategory" : "Add Subcategory"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubCategoryPage;
